import React, { useState, useEffect, useRef} from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Assignment, Build, PermContactCalendar, VerifiedUser, Person, Assessment, AccessTime } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Request from "views/Leave/Request.js";
import Goto from "views/Leave/Goto";
import LeaveForm from "views/Leave/LeaveForm.js";
import MyLeave from "views/Leave/MyLeave";
import MyApprove from "views/Leave/MyApprove";
import HRApprove from "views/Leave/HRApprove";
import LeaveAccrued from "views/Leave/LeaveAccrued.js";
import MyDocument from "views/Leave/MyDocument.js";
//import Admin from "./Admin";
import Admin from "views/Leave/Admin.js";
import LeaveInformation from "views/Leave/LeaveInformation";
import MissionDashboard from "views/Leave/MissionDashboard.js";

// ระบบขอลงเวลาปฏิบัติราชการ (กจ. 1 / กจ. 4)
import AttendanceRequest from "views/HR/Attendance/Request.js";
import MyAttendance from "views/HR/Attendance/MyAttendance.js";
import MyApproveAttendance from "views/HR/Attendance/MyApprove.js";

import axios from "axios";
import getCurrentUser from "utils/getCurrentUser";


let ps;



const useStyles = makeStyles(styles);

export default function Leave({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = useRef(null);
  const currentUser = getCurrentUser();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isHR, setIsHR] = useState(false);
  const [isDeputyOrDev, setIsDeputyOrDev] = useState(() => {
    try {
      const curUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      const uName = (curUser.userName || '').toLowerCase();
      const DEPUTY_USERNAMES = ["supattra", "prapatsorn", "nirumon", "siriporn"];
      const DEV_USERNAMES = ["madarakung", "ton900", "admin"];
      const userDepts = Array.isArray(curUser.userDepartment) ? curUser.userDepartment : [];
      const hasITorHR = userDepts.some(u => u.departmentKey === 105 || u.departmentKey === 108 || (u.departmentKey === 143 && u.userLevelKey === 3));
      return DEPUTY_USERNAMES.includes(uName) || DEV_USERNAMES.includes(uName) || curUser.userLevelKey === -1 || hasITorHR;
    } catch (e) {
      return false;
    }
  });


const routes = [
  {
      name: "แบบขอลา",
      icon: Assignment,
      component: Request,
      layout: "/leave",
      path: "/request",
  },
  {
    name: "ตารางการลาของฉัน",
    icon: PermContactCalendar,
    component: MyLeave,
    layout: "/leave",
    path: "/me",
  },
  {
    name: "รายการอนุมัติลา",
    icon: VerifiedUser,
    component: MyApprove,
    layout: "/leave",
    path: "/myapprove",
  },
  {
    name: "ขอลงเวลาย้อนหลัง",
    icon: AccessTime,
    component: AttendanceRequest,
    layout: "/leave",
    path: "/attendance/request",
  },
  {
    name: "ประวัติการขอลงเวลา",
    icon: PermContactCalendar,
    component: MyAttendance,
    layout: "/leave",
    path: "/attendance/me",
  },
  {
    name: "รายการรับรอง / อนุมัติลงเวลา",
    icon: VerifiedUser,
    component: MyApproveAttendance,
    layout: "/leave",
    path: "/attendance/myapprove",
  },
  {
    name: "Dashboard ภารกิจ",
    icon: Assessment,
    component: MissionDashboard,
    layout: "/leave",
    path: "/mission-dashboard",
    hidden: !isDeputyOrDev
  },
  {
    name: "HR ตรวจสอบ",
    icon: Person,
    component: HRApprove,
    layout: "/leave",
    path: "/hr",
    hidden: !isHR
  },
  {
    name: "วันลาสะสม",
    icon: Build,
    component: LeaveAccrued,
    layout: "/leave",
    path: "/accruedleave",
    hidden: !isHR
  },
  {
    name: "Admin",
    icon: Build,
    component: Admin,
    layout: "/leave",
    path: "/admin",
    hidden: !isHR
  },
  {
    name: "สถิติการลา",
    icon: Build,
    component: LeaveInformation,
    layout: "/leave",
    path: "/information"
  },
];

const switchRoutes = (
  <Switch>
    <Route path="/leave/attendance/request/:id" component={AttendanceRequest} />
    <Route path="/leave/attendance/id/:id" component={AttendanceRequest} />
    {routes.filter(p=>p.hidden==null || p.hidden == false).map((prop, key) => {
     
        return (
          <Route
            //path={(isHR) ? prop.layout + prop.path : "/leave/request"}
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      
      return null;
    })}
        <Route path="/leave/id/:LeaveRequestID" component={Goto} />
        <Route path="/leave/doc" component={MyDocument} /> 
        <Route path="/leave/mission-dashboard" component={MissionDashboard} />

        <Redirect from="/leave" to="/leave/request" />
  </Switch>
);

  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (!currentUser || !currentUser.token) return;

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    axios({
      method: 'post',
      url: "/api/v1/currentdate"
    })
    .then(
       result => {
          const sessionUser = getCurrentUser();
          if (!sessionUser || !sessionUser.token) {
            window.location.href = '/auth/logout';
            return;
          }
          const userDepartments = Array.isArray(sessionUser.userDepartment) ? sessionUser.userDepartment : [];
          const _isHR = userDepartments.filter(u => u.departmentKey == 105
            || u.departmentKey == 108
            || (u.departmentKey == 143 && u.userLevelKey == 3)
            ).length > 0;
          setIsHR(_isHR);

          const uName = (sessionUser.userName || '').toLowerCase();
          const DEPUTY_USERNAMES = ["supattra", "prapatsorn", "nirumon", "siriporn"];
          const DEV_USERNAMES = ["madarakung", "ton900", "admin"];
          setIsDeputyOrDev(DEPUTY_USERNAMES.includes(uName) || DEV_USERNAMES.includes(uName) || sessionUser.userLevelKey === -1 || _isHR);
        },
        error => {console.log(error);}
    );  
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบลา"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
